<template>
  <container-page :title="$t('LoginPage.SigninPage.signin')">
    <a-form class="form"
            :model="formState"
            name="basic"
            :wrapper-col="{ span: 24 }"
            autocomplete="off"
            layout="vertical"
            @finish="onFinish"
            @finish-failed="onFinishFailed">
      <a-form-item name="user"
                   :rules="[{ required: true, message: $t('LoginPage.SigninPage.enterUsernameOrMobile') }]">
        <a-input v-model:value="formState.user"
                 :placeholder="$t('LoginPage.SigninPage.usernameOrMobile')"
                 style="width:100%"
                 autocomplete="off"
                 size='large'>
          <template #prefix>
            <user-outlined />
          </template>
        </a-input>
      </a-form-item>
      <a-form-item name="password"
                   :rules="[{ required: true, message: $t('LoginPage.SigninPage.enterPassword') }]">
        <a-input-password v-model:value="formState.password"
                          :placeholder="$t('LoginPage.SigninPage.password')"
                          autocomplete="off"
                          size='large'>
          <template #prefix>
            <lock-outlined />
          </template>
        </a-input-password>
      </a-form-item>
      <a-form-item>
        <a-col :span="24"
               class="footer">
          <a v-if="!userStore.$state.disableSignUp"
             href="#"
             @click.prevent.stop="toSignUp">{{ $t('LoginPage.SigninPage.signUp') }}</a>
          <a href="#"
             style="float:right"
             @click.prevent.stop="toResetPassword">{{ $t('LoginPage.SigninPage.forgotPassword') }}</a>
        </a-col>
      </a-form-item>
      <a-row>
        <a-button type="primary"
                  html-type="submit"
                  size="large"
                  style="width:100%">{{ $t('LoginPage.SigninPage.signinButton') }}
        </a-button>
      </a-row>
      <a-row v-if="oauth2Components.length > 0"
             class="oauth2">
        <span>{{ $t('LoginPage.SigninPage.otherSigninMethods') }}</span>
        <template v-for="item in oauth2Components"
                  :key='item'>
          <component :is="item"
                     class="item" />
        </template>
      </a-row>
    </a-form>
  </container-page>
</template>


<script setup lang="ts">
import { container } from 'tsyringe'
import { reactive } from 'vue'
import type { Router } from 'vue-router'
import { CORE_ROUTER } from '../../../../core'
import { RESETPASSWORD_PATH, SIGNUP_PATH } from '../constants'
import { useLoginStore } from '../DefaultLoginPagePlugin'
import ContainerPage from './ContainerPage.vue'

const userStore = useLoginStore()
const oauth2Components = userStore.$state.oauth2Components || []

const formState = reactive({
  user: '',
  password: '',
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onFinish = (values: any) => {
  values.username = values.user
  values.mobile = values.user
  userStore.signin('/v1/api/signin', values)
}

const onFinishFailed = (errorInfo: string) => {
  console.log('Failed:', errorInfo)
}

const router = container.resolve<Router>(CORE_ROUTER)
const toSignUp = () => {
  router.push({ path: SIGNUP_PATH })
}

const toResetPassword = () => {
  router.push({ path: RESETPASSWORD_PATH })
}
</script>

<style scoped lang="less">
.form {
  width: 100%;

  .oauth2 {
    margin-top: 10px;
    display: flex;
    justify-content: start;
    align-items: center;

    .item {
      font-size: 24px;
      margin: 0 20px 0 20px;
    }
  }
}
</style>
